module.exports = __webpack_public_path__ + "static/media/purificador1.703cf0b1.pdf";